const PropTypes = require('prop-types');

class SocialNetworkModel {
  constructor() {
    this.name = null;
    this.url = null;
  }
  deserialise(data) {
    this.name = data.social_network;
    this.url = data.social_network_url;
    return this;
  }
}

SocialNetworkModel.propTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

module.exports = SocialNetworkModel;



// WEBPACK FOOTER //
// ./src/common/models/prismic/components/SocialNetworkModel.js